
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyDX5lggWL3U9KkwdMIBDcu_zGW33_Nty7o",
  authDomain: "aristacure-biotech.firebaseapp.com",
  projectId: "aristacure-biotech",
  storageBucket: "aristacure-biotech.firebasestorage.app",
  messagingSenderId: "958812125307",
  appId: "1:958812125307:web:5de51db40c6bfb4226cade",
  measurementId: "G-X8QWEWMW5V"

};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;